/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { City } from '@app/settings/cities/cities.model';
import { CitiesService } from '@app/settings/cities/cities.service';
import { ApiQuery } from '@app/core/http/api-query';
import { Logger } from '@app/core';
import 'moment-timezone';
import swal from 'sweetalert2';
import { Country } from '@app/settings/countries/countries.model';

const log = new Logger('citiesFormComponent');

@Component({
  selector: 'app-cities-form',
  templateUrl: './cities-form.component.html',
  styleUrls: ['./cities-form.component.scss'],
})
export class CitiesFormComponent implements OnInit {
  apiQuery: ApiQuery = new ApiQuery();
  @Input() city: City = null;
  @Input() country: Country = null;
  showCountrySelect = true;
  form: FormGroup;
  // GPOptions = {
  //   types: ['(cities)'],
  // };

  constructor(public modal: NgbActiveModal, private formBuilder: FormBuilder, private cityService: CitiesService) {}

  ngOnInit() {
    // this.generateGPOptions();
    this.createForm();
    this.patchForm();
  }

  //We'll need to fetch the country code and append it when fetching all of the cities to list, because of the new
  // impelentation of the places-autocomplete, country code is
  save() {
    if (this.city && this.city.id) {
      const city: City = this.city.deserialize(this.form.value);
      this.cityService.update(city).subscribe((res) => this.modal.close(res));
    } else {
      const city: City = new City().deserialize(this.form.value);
      if (!city.name || !city.country_id) {
        this.storeCity(city);
        return;
      }
      this.cityService.findDuplicates(city.name, city.country_id).subscribe((duplicates: City[]) => {
        if (!duplicates.length) {
          this.storeCity(city);
          return;
        }
        const names = duplicates.map((duplicate: City) => duplicate.name).join(', ');
        swal
          .fire({
            title: 'Are you sure?',
            text: `A city with this name already exists in this country: ${names}. Do you want to create it anyway?`,
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.storeCity(city);
            }
          });
      });
    }
  }

  handleCityChange(city: any) {
    this.form.get('name').setValue(city.name);
    this.form.get('lat').setValue(Number(city.lat));
    this.form.get('long').setValue(Number(city.lng));
  }

  /*
   * Генерира обекта с опциите за google places
   */
  // generateGPOptions(): void {
  //   setTimeout(() => {
  //     // не работи без timeout не знам защо
  //     if (this.country && this.country.code) {
  //       // сетва в обекта с опциите за google places да търси само в избраната държава
  //       this.GPOptions['componentRestrictions'] = {
  //         country: this.country.code,
  //       };
  //     }
  //   });
  // }

  /**
   *  Парсва стрингосани числа
   * @param number Подава се стрингосано число или число
   */
  number(number: any): number {
    return Number(number);
  }

  /**
   * При преместване на пина на картата пълни полетата lat и long
   * @param event обекта който връща google maps след като пинът бъде преместен
   */
  selectLocation(event: any) {
    if (event && event.latLng) {
      const { lat, lng } = event.latLng.toJSON();
      this.form.get('lat')?.setValue(lat);
      this.form.get('long')?.setValue(lng);
      console.log('Location updated:', lat, lng);
    } else {
      console.warn('Event structure unexpected:', event);
    }
  }

  private storeCity(city: City) {
    this.cityService.store(city).subscribe((res) => this.modal.close(res));
  }

  private createForm() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      alternatenames: [null],
      lat: [null],
      long: [null],
      timezone: ['', [Validators.required]],
      country: [null],
      country_id: [null, [Validators.required]],
      active: [true],
    });
  }

  private patchForm() {
    log.debug('patchForm');
    if (this.city && this.city.id) {
      this.showCountrySelect = false;
      this.cityService.show(this.city.id, new ApiQuery().addInclude('country')).subscribe((city: City) => {
        this.form.patchValue(city);
        this.showCountrySelect = true;
        // if (city.country) {
        //   this.GPOptions['componentRestrictions'] = {
        //     country: city.country.code,
        //   };
        // }
      });
    } else if (this.city) {
      this.form.patchValue(this.city);
    } else if (this.country && !this.city) {
      log.debug(11111, this.country);
      this.form.get('country').patchValue(this.country);
      this.form.get('country_id').patchValue(this.country.id);
      this.form.get('timezone').patchValue(this.country.timezone);
      // this.GPOptions['componentRestrictions'] = {
      //   country: this.country.code,
      // };
    }
  }
}
